import script from "./PlanDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanDetail.vue?vue&type=script&setup=true&lang=js"

import "./PlanDetail.vue?vue&type=style&index=0&id=950d0ec8&lang=css"

const __exports__ = script;

export default __exports__